import { schema, types } from 'papr'

export const nodeSchema = schema(
	{
		name: types.string({ required: true }),
		slug: types.string({ required: true }),
		isActive: types.boolean(),
		isApproved: types.boolean(),
		followersCount: types.number(),
		wikiMarkdown: types.string(),
		wiki: types.string(),
		logo: types.string(),
		cover: types.string(),
		tagline: types.string(),
		numPosts: types.number(),
		dateAdded: types.date(),
		socialMedia: types.object({
			officialWebsite: types.string(),
			twitter: types.string(),
			google: types.string(),
			github: types.string(),
			facebook: types.string(),
			linkedin: types.string(),
		}),
		similarTags: types.array(types.objectId()),
	},
	{
		timestamps: true,
		defaults: {
			followersCount: 0,
			numPosts: 0,
		},
	},
)

export type NodeDocument = (typeof nodeSchema)[0]
export type NodeSchemaOptions = (typeof nodeSchema)[1]
